import React, { useState, useEffect } from 'react';
import '../css/add-event.css'
// import { functionContext } from '../app'

const AddEvent = ({ setcurrentYear, addevent, changeSelectedMonth, currentYear, currentMonth }) => {

  const [newUserName, setnewUserName] = useState('');
  const [newUserevent, setnewUserevent] = useState(`${currentYear}-${currentMonth}-01`);

  // const { } = useContext(functionContext);

  function handleNameChange(e) {
    let neweventName = e;
    // console.log(e)
    setnewUserName(neweventName)
    // console.log(neweventName)
  }

  function handleDateChange(e) {
    // console.log(e)
    let neweventDate = e;
    setnewUserevent(neweventDate)
    // console.log(newUserevent)
  }

   function handleClick(e) {
    if (newUserName === 'Enter event...' || newUserName === "" || newUserName === " ") {
      alert("You cannot send an empty form") 
    } else if (newUserevent === "" || newUserevent === "mm/dd/yyyy" || newUserevent === " ") {
      alert("You cannot send an empty form") 
    } else {
     addevent(newUserName, newUserevent)

     
    //  setTimeout(() => afterEffect(e), 500)
     afterEffect(e)
     clearInputs()

     // event invalidation
    //  setTimeout(() => afterEffect(e), 500) 
    
    
      // console.log(changedMonth)
    }
  }

  function clearInputs() {
    // console.log('running clear inputs inside add events')
    setnewUserName('')
    setnewUserevent('')
  }

  function afterEffect(e) {

    // console.log("is the after effect running?")
    // console.log("this is it: ", e.value.substr(0, 4))


    let changedMonth = (e.value.substr(5, 2));

    if (changedMonth < 10) {
      let lowMonth = changedMonth.substr(1, 1)
      // console.log(lowMonth)
      changeSelectedMonth(+lowMonth + 1)
      // changeSelectedMonth(lowMonth)
      setTimeout(() => changeSelectedMonth(lowMonth), 100)
    } else {
       // console.log(changedMonth)
       changeSelectedMonth(+changedMonth - 1)
       setTimeout(() => changeSelectedMonth(changedMonth), 100)
      changeSelectedMonth(changedMonth)
    }

    setcurrentYear((+e.value.substr(0, 4)) + 1)
    setTimeout(() => setcurrentYear((+e.value.substr(0, 4) - 1)), 200)
  }

  useEffect(() => {

    if (currentMonth < 10) {
      currentMonth = `0${currentMonth}`
    }

    setnewUserevent(`${currentYear}-${currentMonth}-01`) ;
    }, [currentYear, currentMonth]);
  


  return (
    <>
    <div id="addEvent-container">

    <div id="form">
    <input onChange={(e)=> handleNameChange((e.currentTarget.value))} className="addname-input" type="text" 
    placeholder="Enter event..."
    // onFocus={(e) => (e.target.value === "Enter event...") ? setnewUserName("") : console.log("")} 
    // onBlur={(e) => (e.target.value === "" || e.target.value === " ") ? setnewUserName("Enter event...", console.log(newUserName)) : console.log("")} 
    // onBlur={(e) => (e.target.value === "") ? e.target.value = "Enter event..." : console.log("")} 
    value={newUserName} >
    </input>

    <input onChange={(e)=> handleDateChange((e.currentTarget.value))} className="adddate-input" type="date" value={newUserevent} ></input>
    <button onClick={(e) => handleClick(e.currentTarget.previousSibling)} className="addEvent-button">Add event</button>
    </div>

    </div>
    </>
  );
};

export default AddEvent;